import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { getRecipes } from '../actions/recipeActions';
import { Col, Row, Badge } from 'reactstrap';
import Spinner from './Spinner';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';

const RecipePage = (props: any) => {
  const { recipes } = props;
  const history = useHistory();
  const location = useLocation();

  const [searchQuery, setSearchQuery] = useState(location.search);
  const prevSearchQueryRef = useRef(searchQuery);
  const prevLocationSearchRef = useRef(location.search);

  useEffect(() => {
    const parsed = (queryString.parse(location.search) as any);
    let page = 1;
    let query;

    if (parsed.page) {
      page = parsed.page;
    }
    if (parsed.query) {
      query = parsed.query;
    }

    props.getRecipes(page, query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchQuery !== prevSearchQueryRef.current) {
      prevSearchQueryRef.current = searchQuery;
      history.push(`/recipes${searchQuery}`);
    }
  });

  useEffect(() => {
    if (location.search !== prevLocationSearchRef.current) {
      prevLocationSearchRef.current = location.search;
      const parsed = (queryString.parse(location.search) as any);
      let page;
      let query;

      if (parsed.page) {
        page = parsed.page;
      }
      if (parsed.query) {
        query = parsed.query;
      }

      window.scrollTo(0, 0);
      props.getRecipes(page, query);
    }
  });

  const handleReset = () => {
    history.push('/recipes');
  };

  const previousPage = () => {
    const parsed = (queryString.parse(location.search) as any);
    parsed.page = parseInt(parsed.page) - 1;
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const nextPage = () => {
    const parsed = (queryString.parse(location.search) as any);
    if (parsed.page) {
      parsed.page = parseInt(parsed.page) + 1;
    } else {
      parsed.page = 2;
    }
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const handlePageChange = (i) => {
    const parsed = (queryString.parse(location.search) as any);
    parsed.page = i + 1;
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const handleRecipeClick = (recipe) => {
    history.push({
      pathname: `/recipes/${recipe.title.replace(/[^A-Z0-9]+/gi, '-')}/${recipe._id}`,
      state: { recipe },
    });
  };

  const parsed = (queryString.parse(location.search) as any);
  let noResultWarning;

  if (parsed.query && recipes.recipeCount === 0) {
    noResultWarning = true;
  }

  let end;
  let totalItemNumbers = recipes.recipeCount;
  let currentPage;
  if (parsed.page) {
    if (parsed.page > [...Array(Math.ceil(recipes.recipeCount / 24))].length) {
      currentPage = [...Array(Math.ceil(recipes.recipeCount / 24))].length;
    } else if (parsed.page <= 1) {
      currentPage = 1;
    } else {
      currentPage = parsed.page;
    }
  } else {
    currentPage = 1;
  }

  if (24 < totalItemNumbers) {
    end = 24 * currentPage;
    if (end > totalItemNumbers) {
      end = totalItemNumbers;
    }
  } else {
    end = totalItemNumbers;
  }

  return (
    <div className="recipe-page container ">
      <div>
        <Helmet>
          <title>Recipes - Frozberries Victoria</title>
          <meta name="description" content="Recipes - Frozberries Victoria" />
        </Helmet>
      </div>
      {recipes.loading && (
        <div className="text-center">
          <Spinner />
        </div>
      )}

      {parsed.query && (
        <div className="my-2">
          <h5 className="d-inline pr-3" style={{ cursor: 'pointer' }} onClick={handleReset}>
            {' '}
            <Badge color="danger">
              Search: {parsed.query}
              <span className="ml-2" style={{ fontSize: '1.2rem' }}>
                &times;
              </span>
            </Badge>
          </h5>
        </div>
      )}
      {noResultWarning && (
        <div className="text-center  my-5">
          <h5>No results found.</h5>
        </div>
      )}
      <Row className="text-right my-3">
        <Col>
          <div>
            {recipes.recipes.length !== 0 && (
              <h1 style={{ fontSize: '0.9rem' }}>
                Showing{' '}
                {(queryString.parse(location.search) as any).page
                  ? (queryString.parse(location.search) as any).page <= 1
                    ? 1
                    : (queryString.parse(location.search) as any).page >
                        [...Array(Math.ceil(recipes.recipeCount / 24))].length
                      ? ([...Array(Math.ceil(recipes.recipeCount / 24))].length - 1) * 25 - 1
                      : (parseInt((queryString.parse(location.search) as any).page) - 1) * 24 + 1
                  : 1}{' '}
                – {end} of {recipes.recipeCount} results
              </h1>
            )}
          </div>
        </Col>
      </Row>

      <Row className=" py-3">
        {recipes.recipes.length !== 0 &&
          recipes.recipes.map((recipe) => (
            <Col
              lg="4"
              md="6"
              sm="12"
              xs="12"
              key={recipe._id}
              className="  my-2"
              onClick={() => handleRecipeClick(recipe)}
            >
              <div className="shadow-lg border-0 recipes" style={{ cursor: 'pointer' }}>
                <img src={recipe.recipeImage} className="recipe_image" alt={recipe.recipeImage} />
                <div style={{ minHeight: 120 }}>
                  <h5
                    className="text-center  px-4 py-4"
                    style={{ color: 'rgb(14,35,87)', fontSize: 25 }}
                  >
                    {recipe.title}
                  </h5>
                </div>
              </div>
            </Col>
          ))}
      </Row>

      {[...Array(Math.ceil(recipes.recipeCount / 24))].length > 1 &&
        recipes.recipes.length !== 0 && (
          <Row className="text-center mt-5">
            <Col className="text-center ">
              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center">
                  <li
                    className={
                      !(queryString.parse(location.search) as any).page ||
                      (queryString.parse(location.search) as any).page <= 1
                        ? 'disabled page-item '
                        : `page-item`
                    }
                  >
                    <span
                      className="page-link"
                      style={{ color: 'rgb(235,24,79)', cursor: 'pointer' }}
                      onClick={previousPage}
                    >
                      Previous
                    </span>
                  </li>
                  {[...Array(Math.ceil(recipes.recipeCount / 24))].map((page, i) => (
                    <li
                      key={i}
                      className={
                        !(queryString.parse(location.search) as any).page && i + 1 === 1
                          ? 'active page-item'
                          : (queryString.parse(location.search) as any).page <= 1 && i + 1 === 1
                            ? 'active page-item'
                            : (queryString.parse(location.search) as any).page >= 2 &&
                                i + 1 === parseInt((queryString.parse(location.search) as any).page)
                              ? 'active page-item'
                              : (queryString.parse(location.search) as any).page >
                                    [...Array(Math.ceil(recipes.recipeCount / 24))].length &&
                                  i + 1 === [...Array(Math.ceil(recipes.recipeCount / 24))].length
                                ? 'active page-item'
                                : 'page-item'
                      }
                    >
                      <span
                        className="page-link"
                        style={{ color: 'rgb(235,24,79)', cursor: 'pointer' }}
                        onClick={() => handlePageChange(i)}
                      >
                        {i + 1}
                      </span>
                    </li>
                  ))}

                  <li
                    className={
                      (queryString.parse(location.search) as any).page >=
                      [...Array(Math.ceil(recipes.recipeCount / 24))].length
                        ? 'disabled page-item'
                        : 'page-item'
                    }
                  >
                    <span
                      style={{ color: 'rgb(235,24,79)', cursor: 'pointer' }}
                      className="page-link"
                      onClick={nextPage}
                    >
                      Next
                    </span>
                  </li>
                </ul>
              </nav>
            </Col>
          </Row>
        )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  recipes: state.recipes,
});

export default connect(mapStateToProps, { getRecipes })(RecipePage);
